import { createContext } from 'react'
import type { AiDictate } from './useAiDictate'

/**
 * PD-1516 — the editor provides its dictate controller here so the per-field
 * mic shortcuts in the section components invoke the SAME AI Dictate machinery
 * as the toolbar button (AC7). Null outside an editable AI-Dictate context.
 */
export const AiDictateContext = createContext<AiDictate | null>(null)
